/*
 * @Description: 路由
 * @Date: 2024-11-07 15:21:16
 */
import { markRaw } from 'vue';
import { isEqual } from 'lodash';
import { storeToRefs } from 'pinia';
import { RouteLocationNormalized } from 'vue-router';

import appStore from '@/store';
import { EntpAuthStatus } from '@cTypes/user';
import { fieldsToArr } from '@/utils/translator';
import { RouterTransition } from '@/components/transition';
import { useEnterpriseRealStoreSetup } from '../store/index';
import { AuthStepMapping, AuthStepEnum } from '../constants/index';

export const route = [
  {
    path: '/main/enterprise-real',
    name: 'enterprise-real',
    component: markRaw(RouterTransition),
    redirect: '/main/enterprise-real/enterprise-real-index',
    meta: {
      title: 'enterprise-real',
      noLayout: true
    },
    children: [
      {
        path: '/main/enterprise-real/enterprise-real-index',
        name: 'enterprise-real-index',
        meta: {
          title: '注册企业信息',
          noLayout: true
        },
        component: () => import('../views/enterprise-real-index.vue')
      },
      {
        path: '/main/enterprise-real/enterprise-real-result',
        name: 'enterprise-real-result',
        meta: {
          title: '认证结果',
          noLayout: true
        },
        component: () => import('../views/enterprise-real-result.vue')
      },
      {
        path: '/main/enterprise-real/enterprise-real-agreement',
        name: 'enterprise-real-agreement',
        meta: {
          title: '平台协议',
          noLayout: true
        },
        component: () => import('../views/enterprise-real-agreement.vue')
      },
      {
        path: '/main/enterprise-real/enterprise-real-redirect',
        name: 'enterprise-real-redirect',
        meta: {
          title: '易签宝回调页面',
          noLayout: true
        },
        component: () => import('../views/enterprise-real-redirect.vue')
      }
    ]
  }
];

const routeNames = fieldsToArr(route[0].children, 'children', 'path');
export const intercept = async (to: RouteLocationNormalized, next) => {
  const { menuUrls } = storeToRefs(appStore.useMenuStoreSetup);
  const isInCurrentRoutes = routeNames.includes(to.path);
  const { info } = storeToRefs(appStore.useUserStoreSetup);
  const entpAuthStatus: EntpAuthStatus = info.value.entpAuthStatus;
  // TODO: 登录后肯定同步了数据，但是刷新是在app中调用未阻塞加载，会导致路由拦截不及时，小问题

  if (entpAuthStatus !== 30) {
    const store = useEnterpriseRealStoreSetup();
    // 获取当前账号的实名数据
    const entpAuthInfo = await store.getEntpAuthInfo();
    const currentRouter = AuthStepMapping[entpAuthInfo.authStep];

    // 审核通过更新用户信息并跳转
    if (entpAuthInfo.authStep === AuthStepEnum.ELEVEN) {
      await appStore.useUserStoreSetup.initUserSystemData();
      if (!menuUrls.value?.[0]) {
        next('/');
      } else {
        next(menuUrls.value[0]);
      }
      return Promise.reject('已认证拦截');
    }

    // 不处于认证页面集合中，跳转至认证页面
    if (!isInCurrentRoutes) {
      next({
        name: currentRouter.name,
        query: currentRouter.query
      });
      return Promise.reject('企业认证拦截');
    }

    // 协议跳转到信息页面不用拦截
    if (
      currentRouter.name === 'enterprise-real-agreement' &&
      to.name === 'enterprise-real-index' &&
      store.agreementChecked
    ) {
      next();
      return Promise.reject('拦截');
    }

    // 处于认证页面集合中，判断是否是指定页面
    if (
      to.name !== currentRouter.name ||
      (to.name === currentRouter.name &&
        !isEqual(to.query, currentRouter.query))
    ) {
      next({
        name: currentRouter.name,
        query: currentRouter.query
      });
      return Promise.reject('页面不一致拦截');
    } else {
      next();
      return Promise.reject('拦截');
    }
  }
  // 已认证
  else {
    // 处于认证页面重定向到第一个菜单
    if (isInCurrentRoutes) {
      if (!menuUrls.value?.[0]) {
        next('/');
      } else {
        next(menuUrls.value[0]);
      }
      return Promise.reject('已认证拦截');
    }
    // 正常跳转
    else {
      return Promise.resolve();
    }
  }
};
